<template>
 
<v-container > 

    <v-card class="mx-auto m4u_tertiary" :max-width ="$vuetify.breakpoint.smAndDown ? '85vw' : '40vw'" >

        <v-card-title>
            <h2 class="m4u_text--text mb-2">New {{ TypeDesc }}</h2>
        </v-card-title>

        <v-card-text>
<!--DIALOG FOR DRAFTS -->
      <v-dialog
      v-model="draft"
      fullscreen
      persistent
      max-width="290"
    >
      <v-card>
      
          <h2 class="m4u_text--text">You didn't add a circle. Do you want to save this as a draft?</h2>

        <v-card-actions>
          <v-spacer></v-spacer>


          <v-btn
            color="red darken-1"
            text
            @click="addMemory()"
          >
            Save Draft
          </v-btn>

          <v-btn
            color="green darken-1"
            text
            @click="draft=false"
          >
           Return
          </v-btn>


        </v-card-actions>
      </v-card>
    </v-dialog>
<!-- START OF UPLOADING FILES -->
<!-- BEGINNING OF ADD MEDIA DIALOG -->

<v-row justify="center">
    <v-menu 
      top

    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn 
          color="primary"
          class="m4u_text--text"
          v-bind="attrs"
          v-on="on"
        >
        Type
        <v-icon>mdi-chevron-down</v-icon>
        </v-btn>
      </template>

      <v-list>
        <v-list-item>
          <v-list-item-title  @click="setType(1)" class="m4u_text--text">Memory</v-list-item-title>
        </v-list-item>
        <v-list-item>
          <v-list-item-title  @click="setType(3)" class="m4u_text--text">Recipe</v-list-item-title>
        </v-list-item>
        <v-list-item>
          <v-list-item-title  @click="setType(2)" class="m4u_text--text">Interview</v-list-item-title>
        </v-list-item>
        <v-list-item>
          <v-list-item-title  @click="setType(4)" class="m4u_text--text">Tradition</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>

    <v-dialog
      v-model="idialog"
      persistent
      max-width="600px"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          color="primary"
          dark
          v-bind="attrs"
          v-on="on"
          class="mediaBtn"
        >
         <v-icon class="m4u_text--text">mdi-camera-outline</v-icon>
        </v-btn>
      </template>
      <v-card>
        <v-card-title>
          <span class="headline m4u_text--text">Add Photo</span>
        </v-card-title>
        <v-card-text>
          <v-container>
    <v-row no-gutters justify="center" align="center">
      <v-col cols="6">
    <div class="large-12 medium-12 small-12 cell">

        <input type="file" id="file" ref="file" class="m4u_text--text" v-on:change="handleFileUpload()"/>

    </div>
      </v-col>
    </v-row>
    

    <v-alert v-if="message" border="left" color="blue-grey" dark>
      
    </v-alert>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="secondary"
            text
            @click="cancelFileUpload()"
            class="teal--text text--accent-4"
          >
            Cancel
          </v-btn>

        </v-card-actions>
      </v-card>

    </v-dialog>

        <v-dialog  v-if="TypeDesc === 'Interview'"
      v-model="dialogi"
      scrollable
      max-width="600px"
    >

      <template v-slot:activator="{ on, attrs }">
        <v-btn
          color="primary"
          dark
          class="m4u_text--text mb-4"
          v-bind="attrs"
          v-on="on"
          @click="getInterviews()"
         
        >
          <v-icon class="m4u_text--text">mdi-lightbulb-on-outline</v-icon>
        </v-btn>

      </template>


      <v-card>
        <v-card-title class="m4u_text--text">Interview Suggestions</v-card-title>
        <v-divider></v-divider>
        <v-card-text style="height: 300px;">
<v-card
    class="mx-auto"
    max-width="500"
  >
    <v-list>
      <v-list-item-group v-model="selectedInterview">
        <v-list-item
          v-for="interview in interviews" :key="interview.InterviewID"
        >
          <v-list-item-content>
            <div class="suggestionDiv m4u_text--text">
            {{interview.IntQuestion}}
            </div>
          </v-list-item-content>
        </v-list-item>
                    <v-divider></v-divider>
      </v-list-item-group>
    </v-list>
  </v-card>

        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn
            class="teal--text text--accent-4"
            text
            @click="dialogi = false"
          >
            Close
          </v-btn>
          <v-btn
            class="teal--text text--accent-4"
            text
            @click="setInterview()"
          >
            Select
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

      <v-dialog  v-if="TypeDesc === 'Tradition'"
      v-model="dialogt"
      scrollable
      max-width="300px"
    >

      <template v-slot:activator="{ on, attrs }">
        <v-btn
          color="primary"
          class="mb-4"
          dark
          v-bind="attrs"
          v-on="on"
          @click="getTraditions()"
        >
          <v-icon class="m4u_text--text">mdi-lightbulb-on-outline</v-icon>
        </v-btn>

      </template>


      <v-card>
        <v-card-title class="m4u_text--text">Tradition Suggestions</v-card-title>
        <v-divider></v-divider>
        <v-card-text style="height: 300px;">
<v-card
    class="mx-auto"
    max-width="500"
  >
    <v-list>
      <v-list-item-group v-model="selectedTradition">
        <v-list-item
          v-for="tradition in traditions" :key="tradition.TraditionTypeID"
        >
          <v-list-item-content>
          <div class="suggestionDiv m4u_text--text">
            {{tradition.TraditionName}}
            </div>
          </v-list-item-content>
        </v-list-item>
      </v-list-item-group>
    </v-list>
  </v-card>

        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn
            class="teal--text text--accent-4"
            text
            @click="dialogt = false"
          >
            Close
          </v-btn>
          <v-btn
            class="teal--text text--accent-4"
            text
            @click="setTradition()"
          >
            Select
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>

    <v-progress-linear
    v-if="progressOn"
      indeterminate
      color="teal"
    ></v-progress-linear>
<!-- END OF ADD MEDIA DIALOG -->

<div v-for="media in medialocs" :key="media.MediaID" class="GalleryDiv"  >
  

    <div >
<MediaCard :mediaLocs="media.MediaLoc" :mediatype="media.MediaType" :mediaUser="user.UserID" :mediaFeature="media.FeatureMedia" :edit='true' @reloadMedia="resetMedia()"/>

  </div>

</div>

    <v-form px-3 >
<v-row>
      <div style="width:75%;" class="ml-5">
        <v-textarea v-if="storyData.StoryTypeID !== 2 && storyData.StoryTypeID !== 4" label="Title"  color="m4u_text" 
        v-model="storyData.StoryTitle" :rules="titleRules" auto-grow rows="2" rowHeight="10"></v-textarea>
      </div>
</v-row> 

      <v-row >
        <div style="width:75%;" class="ml-5">
        <v-textarea v-if="storyData.StoryTypeID === 2" label="Interview Question" color="m4u_text" 
        v-model="storyData.StoryTitle" :rules="titleRules" auto-grow rows="2" rowHeight="10"></v-textarea>
        </div>
      </v-row>

 <v-row>
      <div style="width:75%;" class="ml-5">
      <v-textarea v-if="storyData.StoryTypeID === 2" label="Interviewee Name" color="m4u_text" auto-grow rows="2" rowHeight="10"
        v-model="storyData.Interviewee" :rules="titleRules" ></v-textarea>    
      </div>
 </v-row>
      <v-row >
        <div style="width:75%;" class="ml-5">
        <v-textarea v-if="storyData.StoryTypeID === 4" label="Name a tradition" v-model="storyData.StoryTitle" :rules="titleRules" 
        auto-grow rows="2" rowHeight="10" color="m4u_text"></v-textarea>
        </div>
        </v-row>
        <v-row>
        <div style="width:75%;" class="ml-5">
        <v-textarea label="Ingredients" v-model="storyData.StoryIngredients" v-if="storyData.StoryTypeID === 3" color="m4u_text" auto-grow rows="4" rowHeight="10"></v-textarea>
        </div>
        </v-row>
        <v-row>
        <div style="width:75%;" class="ml-5">
        <v-textarea label="Directions" v-model="storyData.StoryText" v-if="storyData.StoryTypeID === 3" color="m4u_text" auto-grow rows="4" rowHeight="10"></v-textarea>
        </div>
        </v-row>
        <v-row>
        <div style="width:75%;" class="ml-5">
        <v-textarea label="Describe this memory" v-model="storyData.StoryText" v-if="storyData.StoryTypeID !== 3" color="m4u_text" auto-grow rows="4" rowHeight="10"></v-textarea>
         </div>
         </v-row>
         <v-row>
        <div style="width:20rem;" class="ml-5">
        <v-select
        v-model="CircleID"
        :items="circles"
        label="Share with..."
        item-text="CircleName"
        item-value="CircleID"
        return-object
        required
        color="m4u_text"
        class="m4u_text--text"
        ></v-select>

        </div>
        <div class="ml-3">
          <v-checkbox
          v-model="storyData.Hidden"
          label="Share only in time capsules?"
          class="hide"
          color="m4u_text"
        ></v-checkbox>

        </div>
        </v-row>
    </v-form>
        <!--- START DIALOG FOR ADDING TO BOOKS --->
        <v-dialog
            v-model="bookDialog"
            scrollable
            max-width="50%"
          >
            <template v-slot:activator="{ on, attrs }">

            </template>
            <v-card >
              <v-card-title class="primary m4u_text--text">Want to add this memory to any books?</v-card-title>
              <v-card-text v-if="books.length === 0" class="m4u_text--text">There are no more books to add this story to.</v-card-text>
              <v-divider></v-divider>
              <v-card-text style="height: 300px;">

              <v-checkbox 
              @click="updateBooks(book.BookID, book.BookStatus)"
              v-for="book in books" :key="book.BookID"
              v-model="book.BookStatus"
              color="m4u_text"
              class="m4u_text--text"
            :label="book.BookTitle"
            :value="book.BookStatus">
            </v-checkbox>

              </v-card-text>
              <v-divider></v-divider>
              <v-card-actions>
                <v-btn
                  class="teal--text text--accent-4"
                  text
                  @click="closeBooks()"
                >
                  Close
                </v-btn>

              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-card-text>

        <v-card-actions>
            <v-row
        align="center"
        justify="space-around">


            <v-btn
            color="primary"
          dark
            text
            icon
            large
            @click="draftCheck()"
          >
            <v-icon class="teal--text text--accent-4">mdi-check-bold</v-icon>
          </v-btn>
          <v-btn
            color="teal"
            dark
            text
            large
            v-on:click="addDraft()"
          >
          Save Draft
          </v-btn>
          <v-btn
            color="primary"
            dark
            text
            icon
            large
            v-on:click="resetNewMemory()"
          >
          <v-icon class="teal--text text--accent-4">mdi-window-close</v-icon>
          </v-btn>
          </v-row>

        </v-card-actions>
    </v-card>

    </v-container>
</template>
<script>
import MediaCard from '../components/MediaCard';
import EventService from '@/services/EventService.js'; 

export default {
  name: 'newmemory',
  components: {
    MediaCard
  },
    data() {
    return {
      toggle_exclusive: 1,
      progressOn: false,
      TypeDesc: 'Memory',
      dialog: false,
      dialogtrad: '',
      dialogt: false,
      bookDialog: false,
      books: [],
      selectedTradition: '',
      dialoginterview: '',
      dialogi: false,
      selectedInterview: '',
      circles: [],
      files: [],
      componentKey: '0',
      selected: this.circles,
      storyData: {
          StoryID: 0,
          StoryTypeID: 1,
          StoryTitle: '',
          StoryText: '',
          Memory: true,
          Recipe: false,
          Tradition: false,
          Interviewee: '',
          StoryIngredients: '',
          Hidden: false,
       },
      draft: false,
       CircleID: '',
       medialocs: [],
       mediaUpdates: true,
       currentFile: undefined,
      selectedFile: null,
      message: '',
      idialog: false,
      vdialog: false,
      file: '',
      storyID: 0,
      titleRules: [
        v => !!v || 'This is required',
        v => (v && v.length >= 5) || 'Must be at least 5 characters',
      ],
      traditions: [],
      interviews: [],
      memoryID: '',

       predefinedBtnProps: {
          xs: {
            'x-small': true
          },
          sm: {
            'small': true
          },
          md: {
            
          },
          lg: {
            'large': true
          },
          xl: {
            'x-large': true
          }
        }
       }
    },

  mounted() {
    
    this.getMyCircles(this.user.UserID);
    this.getMedia();
    if (this.loginState !== true) {
    router.push('home') }
  },

 computed: {
  user(){
    return this.$store.state.user
  },

  token() {
    return this.$store.state.token
  },


  refreshToken() {
    return this.$store.state.refreshToken
  },

  
  loginState(){
    return this.$store.state.loginState
  },

    btnProps()  {
    let props = {}
    switch(this.$vuetify.breakpoint.name) {
      case 'xs':
        props.color = 'blue'
        props['x-small'] = true
        break
      case 'sm':
        props.color = 'blue'
        props['small'] = true
        break  
      case 'lg':
        props.color = 'green'
        props['large'] = true
        break
        case 'xl':
        props.color = 'purple'
        props['x-large'] = true
        break 
      default: 
        props.color = 'red'
    }
    return props
  }

    
  },
    created() {
    this.setType(1)
    },


  methods: {


    async getMyCircles() {
      await EventService.getMyCircles(this.user.UserID)
      .then(
        (circles => {
          this.$set(this, "circles", circles);
 //           console.log('this is what circles is after call to event', this.circles)
        }).bind(this)

      );
    },


      setType(sentStoryID) {
          if (sentStoryID === 1) {this.TypeDesc = 'Memory'; this.storyData.StoryTypeID = 1} 
          if (sentStoryID === 2) {this.TypeDesc = 'Interview'; this.storyData.StoryTypeID = 2; } 
          if (sentStoryID === 3) {this.TypeDesc = 'Recipe'; this.storyData.StoryTypeID = 3} 
          if (sentStoryID === 4) {this.TypeDesc = 'Tradition'; this.storyData.StoryTypeID = 4} 
      },

      async draftCheck() {
          if (this.CircleID === '') {
            this.draft = true;
          } else {
            this.addMemory();
          }
      },

        async addDraft() {
          this.progressOn = true;
        await (EventService.newDraft(this.user.UserID, this.storyData))
        .then(async (newMemory) => {
          this.storyData.StoryTypeID = 1
          this.storyData.StoryTitle = ''
          this.storyData.StoryText = ''
          this.storyData.Memory = true
          this.storyData.Recipe = false
          this.storyData.Interview = false
          this.storyData.Tradition = false
          this.storyData.TypeDesc = 'Memory'
          this.storyData.Interviewee = ''
          this.storyData.StoryIngredients = ''
          this.storyData.Hidden=false
          this.CircleID = ''
          this.toggle_exclusive = 1
            await (EventService.getThisStory(newMemory[0].InsertedId))
          .then (
            (newStory) => {
            this.$set(this, "storyData", newStory[0]);
            this.progressOn = false;
        }) }
             )
          
          this.$store.dispatch('setStory', this.storyData);
          this.$parent.$emit('memoriesChanged')
          this.$router.push({ name: 'Home' })
//          this.$router.push({ name: 'memoryreader', params: { incomingStoryId: this.memoryID } })
        
    },

        async addMemory() {
//          console.log('reaching addMemory')
          this.progressOn = true;
        await (EventService.newMemory(this.user.UserID, this.storyData, this.CircleID.CircleID))
        .then(async (newMemory) => {
          this.storyData.StoryTypeID = 1
          this.storyData.StoryTitle = ''
          this.storyData.StoryText = ''
          this.storyData.Memory = true
          this.storyData.Recipe = false
          this.storyData.Interview = false
          this.storyData.Tradition = false
          this.storyData.TypeDesc = 'Memory'
          this.storyData.Interviewee = ''
          this.storyData.StoryIngredients = ''
          this.storyData.Hidden = false
          this.CircleID = ''
          this.toggle_exclusive = 1
            await (EventService.getThisStory(newMemory[0].InsertedId))
          .then (
            (newStory) => {
            this.$set(this, "storyData", newStory[0]);
            console.log('new story id is: ', this.storyData.StoryID)
            this.progressOn = false;
        })
        .then (() => {
          this.$store.dispatch('setStory', this.storyData);
          this.$parent.$emit('memoriesChanged')
        })
        .then(() => {
          this.getMyBooks();
        })
        .then(() => {
          this.bookDialog=true;
        })
        }
             )
//          this.$router.push({ name: 'Home' })       
    },
        async resetNewMemory() {
        await (EventService.removeNewMedia(this.user.UserID))
        .then( () => {
         this.storyData.StoryTypeID = 1 
          this.storyData.StoryTitle = ''
          this.storyData.StoryText = ''
          this.storyData.Memory = true
          this.storyData.Recipe = false
          this.storyData.Interview = false
          this.storyData.Tradition = false
          this.storyData.TypeDesc = 'Memory'
          this.storyData.Interviewee = ''
          this.storyData.StoryIngredients = ''
          this.storyData.Hidden = false
          this.CircleID = ''
          this.toggle_exclusive = 1
          this.$router.push('Home')
        })
        },

        async resetMedia() {
          await (EventService.getNewMedia(this.user.UserID))
        .then(
        (medialocs => {
          this.$set(this, "medialocs", medialocs);
        }).bind(this) 
      );
        },

        async getMedia() {
        await (EventService.getNewMedia(this.user.UserID))
        .then(
        (medialocs => {
          this.$set(this, "medialocs", medialocs);
        }).bind(this) 
      );  
        },

          async getTraditions() {
        await (EventService.getTraditions())
        .then(
        (traditions => {
          this.$set(this, "traditions", traditions);
        }).bind(this) 
      );  
        },

          async getInterviews() {
        await (EventService.getInterviews())
        .then(
        (interviews => {
          this.$set(this, "interviews", interviews);
        }).bind(this) 
      );  
        },

    async setTradition() {
      this.dialogt = false;
      this.storyData.StoryTitle = this.traditions[this.selectedTradition].TraditionName
    },

    async setInterview() {
      this.dialogi = false;
      this.storyData.StoryTitle = this.interviews[this.selectedInterview].IntQuestion
    },

      async updateBooks(bookID, bookStatus) {
        console.log('bookID, bookStatus, storyID are: ', bookID, bookStatus, this.storyData.StoryID)
      if (bookStatus === true) {
      await (EventService.addToBooks(bookID, this.storyData.StoryID))
      .then(async () => {
        await this.getMyBooks()
      })
      }
      if (bookStatus === null || bookStatus === false) {
      await (EventService.removeFromBooks(bookID, this.storyData.StoryID))
      .then(async () => {
        await this.getMyBooks()
      })
      }
      },

      async closeBooks() {
        this.bookDialog = false;
        this.$router.push('Home')
      },

      async getMyBooks() {
      await (EventService.getBooksToAddStory(this.user.UserID, this.storyData.StoryID))
        .then(
        (books => {
          this.$set(this, "books", books);
          console.log('incoming books are: ', books)
        }).bind(this) 
      )
      .then(
          () => {
            if(this.books === null) {
              this.noBookMsg = true;
            } 
          }
        )
      },

  async handleFileUpload(){
    this.file = this.$refs.file.files[0];
      this.idialog = false
      let formData = new FormData();
      formData.append('file', this.file);
      formData.append('userID', this.user.UserID);
      formData.append('storyID', 0);
      formData.append('reauthToken', this.$store.state.reauthToken)

      await (EventService.addNewBlob(formData))
      .then(() => {
            this.selectedFile = null;
      })
      .then(() => {
        this.resetMedia()
        this.$nextTick()
      })
  },

    async cancelFileUpload() {
        this.file = ''
        this.idialog = false

    }

  } 
}



</script>
<style lang="scss" scoped>

.hide .v-input--selection-controls__input {
  color: #bbb7a9;
}
   .GalleryDiv {
     margin: 15px;
     max-width: 30%;
   }
   .lookupDiv {
     margin-left: 3%;
     margin-top: 5%;
   }

.mediaBtn {
    margin-left: 15px;
    margin-bottom: 15px;
}

.suggestionDiv {
  border-bottom-style: solid;
  border-bottom-width: 1px;
  border-color: orange;
}
</style>